import * as React from 'react';
import './noteSection.module.scss';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes';
import { CtaBox } from './TopSection';
import { observer } from 'mobx-react';

export const NoteSection = observer(() => (
    <div styleName="section">
        <div styleName="text">
            会員の皆様も受講のなかで感じられているかもしれませんが、SHEは受講生同士のコミュニティというものをとても大切にしております。<br />
            <br />
            “オンライン学習”と聞いて、そのSHEの良さが失われてしまうのでは…？と不安になられた方もいらっしゃるかもしれませんが、決してそんなことはありません。<br />
            何度でも巻き戻しながら学べるオンライン講座や、コーチング会・もくもく会などで、これまで以上に学習がしやすく、頑張る仲間と刺激をしあえる環境を用意させていただいております。<br />
            <br />
            これまでに以上にパワーアップしたSHELikesを是非ご活用頂き、皆様が夢の実現にまた一歩近付けることを、スタッフ一同心から願っております。
        </div>
        <CtaBox mobile={GlobalStatesV3.viewport.isMobile} />
    </div>
));
